import React from 'react';
import "./appinsights";
import "./clarity";
import { createRoot } from 'react-dom/client';
import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import { BrowserRouter } from 'react-router-dom';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from './appinsights';
import App from './App';
import { AppProvider } from './context/AppContext';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import AuthGate from "./AuthGate";

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    // AppInsightsContext.Provider habilita useAppInsightsContext() en toda la app
    // y conecta el ReactPlugin con el árbol de componentes React.
    <AppInsightsContext.Provider value={reactPlugin}>
      <BrowserRouter>
        <AppProvider>
          <KindeProvider
            clientId={ process.env.REACT_APP_VITE_KINDE_CLIENT_ID as string }
            domain={ process.env.REACT_APP_VITE_KINDE_DOMAIN as string }
            logoutUri={ process.env.REACT_APP_VITE_KINDE_LOGOUT_URL as string }
            audience={ process.env.REACT_APP_VITE_KINDE_AUDIENCE as string }
            redirectUri={ process.env.REACT_APP_VITE_KINDE_REDIRECT_URL as string }
          >
            <AuthGate>
              <App />
            </AuthGate>
          </KindeProvider>
        </AppProvider>
      </BrowserRouter>
    </AppInsightsContext.Provider>
  );

  reportWebVitals();
} else {
  console.error('Root element not found');
}
